import axios from "axios";
import { useEffect, useState } from "react";

// export const baseUrl = "https://api.fleetassist.in/public/api/";
// export const mediaUrl = "https://api.fleetassist.in/storage/app/public/uploads";
// export const baseUrl = "http://127.0.0.1:8000/api/";
// export const mediaUrl = "http://127.0.0.1:8000/storage/uploads";
export const baseUrl = "https://client.fleetassist.in/public/api/";
export const mediaUrl = "https://client.fleetassist.in/storage/uploads";

export const uploadFile = async (image) => {
  // 1. Get token from localStorage
  const token = localStorage.getItem("token");

  // 2. Check if token exists
  if (!token) {
    console.error("No token found in localStorage");
    throw new Error("Unauthorized: Token not found");
  }

  // 3. Create FormData and append image
  const formdata = new FormData();
  formdata.append("image", image);

  try {
    // 4. Send the request with Authorization header
    const file_response = await axios.post(`${baseUrl}fileupload`, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });

    // 5. Return the filename from response
    const filename = file_response.data.filename;
    return filename;
  } catch (error) {
    console.error("File upload failed:", error.response || error.message);
    throw error;
  }
};




const useCurrency = () => {
  const [currency, setCurrency] = useState("");
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchCurrency = async () => {
      // setLoading(true);
      try {
        const response = await axios.get(`${baseUrl}general_setting/getall`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCurrency(response.data[0].currency);
      } catch (error) {
        console.error("Error fetching currency:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchCurrency();
  }, []);

  return { currency };
};

export default useCurrency;

export async function apiGet(endpoint) {
    const token = localStorage.getItem("token");

  // 2. Check if token exists
  if (!token) {
    console.error("No token found in localStorage");
    throw new Error("Unauthorized: Token not found");
  }
  const response = await axios.get(`${baseUrl}${endpoint}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

export async function apiPost(endpoint, body = {}) {
    const token = localStorage.getItem("token");

  // 2. Check if token exists
  if (!token) {
    console.error("No token found in localStorage");
    throw new Error("Unauthorized: Token not found");
  }
  const response = await axios.post(`${baseUrl}${endpoint}`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}